import { QuoteStatus } from '@graphql';
import { CUSTOMER_APPLICATION_BASE_URL } from './constants';

// this can be shared
export const getTrackingId = () => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('trackingId') ?? '';
};

export function isJointApplicant() {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('joint') === 'true';
}

export const redirectToApplicationForm = (trackingId: string) => {
  return window.location.replace(
    encodeURI(
      `${CUSTOMER_APPLICATION_BASE_URL[import.meta.env.VITE_ENVIRONMENT ?? 'staging']}?trackingId=${trackingId}${isJointApplicant() ? `&joint=true` : ''}`,
    ),
  );
};

export const getVendorInitials = (name: string) => {
  const initials = name
    .split(' ')
    .map(item => item[0])
    .join('');

  if (initials.length <= 2) {
    return initials;
  } else {
    return initials.substring(0, 2);
  }
};

export const accessibleQuote = (quoteStatus: QuoteStatus): boolean => {
  const accessibleStatuses = [QuoteStatus.SENT, QuoteStatus.STARTED];
  return accessibleStatuses.includes(quoteStatus);
};
